/* cart-gift.js */

(function () {
  'use strict';

  const CART_ADD_URL =
    (window.theme && theme.routes && theme.routes.cartAdd) ? theme.routes.cartAdd : '/cart/add.js';
  const CART_CHANGE_URL =
    (window.theme && theme.routes && theme.routes.cartChange) ? theme.routes.cartChange : '/cart/change.js';

  async function postJSON(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      const msg = (data && (data.description || data.message)) || ('Request failed: ' + res.status);
      const err = new Error(msg);
      err.response = data;
      throw err;
    }
    return data;
  }

  class CartGiftManager {
    constructor() { this.init(); }

    init() {
      document.addEventListener('click', (evt) => {
        const tab = evt.target.closest('.js-gift-tab');
        if (tab) return this.handleTabClick(tab);

        const btn = evt.target.closest('.js-gift-choose');
        if (btn) return this.handleChooseClick(btn);
      });
    }

    handleTabClick(tab) {
      const row = tab.closest('#cart-gift-row');
      if (!row) return;
      const newIndex = tab.dataset.giftIndex;
      const newThreshold = tab.dataset.threshold;

      if (newIndex != null) row.setAttribute('data-active-index', newIndex);
      if (newThreshold != null) row.setAttribute('data-selected-threshold', newThreshold);
    }

    async handleChooseClick(btn) {
      if (!btn || btn.hasAttribute('disabled')) return;
      const row = btn.closest('#cart-gift-row');
      if (!row) return;
      // enhanced-cart-items 容器：用于 refresh
      const container = btn.closest('enhanced-cart-items') || document.querySelector('enhanced-cart-items');

      // 有 slot 时，Liquid 建议给 row：
      // data-slot-line-key="{{ slot.key }}"
      // data-slot-line-index="{{ slot.index | plus: 1 }}"
      const lineKey = row.dataset.slotLineKey || btn.dataset.lineKey || '';
      const lineIndex = btn.dataset.line || row.dataset.slotLineIndex || '';

      // ✅ 一律使用 giftGid 写入 _gift_choice（你的 Liquid button 已经带 data-gift-gid）
      const giftGid = btn.dataset.giftGid || btn.dataset.giftId || '';
      const slotVariantId = row.dataset.slotVariantId || '';
      const hasSlot = row.dataset.giftSlot === 'true';

      if (!giftGid) return;
      // UI lock
      if (container) container.classList.add('pointer-events-none');
      btn.classList.add('loading');
      const originalText = btn.innerHTML;
      btn.innerHTML = '...';
      btn.disabled = true;

      try {
        const props = {
          _is_gift_slot: '1',
          _gift_choice: String(giftGid),
          _last_update: String(Date.now())
        };

        if (hasSlot) {
          // ✅ 最稳：优先用 line key 更新（不受排序影响）
          if (lineKey) {
            await postJSON(CART_CHANGE_URL, {
              id: String(lineKey),
              quantity: 1,
              properties: props
            });
          } else {
            // ⚠️ 兜底：line index
            if (!lineIndex) throw new Error('Missing line key and line index');
            await postJSON(CART_CHANGE_URL, {
              line: Number(lineIndex),
              quantity: 1,
              properties: props
            });
          }
        } else {
          // ✅ 首次选择：购物车里还没有 slot line -> add 创建 slot
          if (!slotVariantId) throw new Error('Missing slot variant id (data-slot-variant-id)');
          await postJSON(CART_ADD_URL, {
            items: [{ id: Number(slotVariantId), quantity: 1, properties: props }]
          });
        }

        // ✅ 最正确：让 enhanced-cart-items 自己 refresh sections
        if (container && typeof container.refresh === 'function') {
          await container.refresh();
        } else {
          window.location.reload();
        }

      } catch (e) {
        console.error('[cart-gift] Gift operation failed:', e);

        if (container) container.classList.remove('pointer-events-none');
        btn.innerHTML = originalText;
        btn.classList.remove('loading');
        btn.disabled = false;

        if (container) {
          container.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: { error: e.message || 'Failed to update gift. Please try again.' }
          }));
        } else {
          alert(e.message || 'Failed to update gift. Please try again.');
        }

      } finally {
        // refresh 成功 DOM 会被替换；出错没刷新则需要恢复
        if (container) container.classList.remove('pointer-events-none');
        if (btn && document.body.contains(btn)) {
          btn.classList.remove('loading');
          btn.innerHTML = originalText;
          btn.disabled = false;
        }
      }
    }
  }

  new CartGiftManager();
})();